import { useAddFavoriteGame, useApiContext, useDeleteFavoriteGame } from 'react-easyrocket';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { getFavoriteState } from '../utils.ts';
import { favoriteGamesStore } from '../index.ts';

type useFavoriteGamesHandlerInput = {
  gameId: number | undefined;
  defaultState: boolean | undefined;
};

export const useFavoriteGamesHandler = ({ gameId, defaultState }: useFavoriteGamesHandlerInput) => {
  const { isAuthenticated } = useApiContext();

  const { mutateAsync: addRequest } = useAddFavoriteGame();
  const { mutateAsync: deleteRequest } = useDeleteFavoriteGame();

  const { isFavorite, toggleFavorite } = useStoreWithEqualityFn(
    favoriteGamesStore,
    (store) => ({
      toggleFavorite: store.toggleFavorite,
      isFavorite: getFavoriteState(gameId, store, defaultState)
    }),
    shallow
  );

  const handleFavorite = (
    gameId: useFavoriteGamesHandlerInput['gameId'],
    isAuth = isAuthenticated
  ) => {
    if (gameId === undefined || defaultState === undefined || !isAuth) return;
    toggleFavorite({
      gameId,
      deleteRequest,
      addRequest,
      currentState: isFavorite
    });
  };

  return { handleFavorite, isFavorite };
};
